require('@/components/common/css/head.css');
import {mapState} from 'vuex';
import utils from '@/common/libs/utils';
import localforage from 'localforage';
import CityCodeData from '@/common/libs/CityCodeData';

export default{
  name: 'Header',
  computed: mapState({
    city: state => state.home.city,
    isShowHeader: state => state.header.isShowHeader,
    mine: state => state.mine.state,
    logo: state => state.home.logo
  }),
  methods: {
    getCity() {
      var city = CityCodeData.getCityByShort(this.$route.params.city);
      console.log('当前城市：', city);
      this.$store.dispatch('getCity', {
        city_code: city.city_code
      });
    },
    getLocation() {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(this.getPositionSuc, this.getPositionErr);
      } else {
        this.$store.dispatch('toast', {title: '当前浏览器未提供定位服务，请使用其他浏览器打开', show: true});
        this.getPositionSuc({});
      }
    },
    getPositionSuc(position) {
      let vm = this;
      let lat = '', lng = '';

      // if (position.coords) {
      //   lat = position.coords.latitude;
      //   lng = position.coords.longitude;
      // }

      let obj = {
        city_code: '',
        city_abbreviation: '',
        lat,
        lng
      };

      vm.$store.dispatch('getCity', obj);
    },
    getPositionErr() {
      this.getPositionSuc({});
    },
    changeCity() {
      if (utils.cookie.get('canSwitchCity') && utils.cookie.get('canSwitchCity') == 0) {

        this.$store.dispatch('toast', {title: '学员请联系班主任修改学员卡绑定城市', show: true});

        return;
      }

      //显示loading
      this.$store.commit('isShowLoading', true);

      this.$router.push({name: 'changeCity', query: {
        name: this.$route.path
      }});
    },
    goTop() {

      this.$refs.head.scrollIntoView({block: 'start', behavior: 'smooth'});
    },
    home() {
      if (this.$route.name == 'notOnline') {

        return;
      }
      this.$router.push({name: 'Home'});
    },
    phoneCall() {
      let page_view = this.$route.fullPath.indexOf('mine') !== -1 ? '我的' : '首页';

      page_view = this.$route.fullPath.indexOf('course') !== -1 ? '选课中心' : page_view;

      let stater = this.$store.state;
      let obj = {
        'page_view': page_view,
        'page_name': this.$route.fullPath,
        'locate_city': stater.home.city.city_name,
        'user_grade': stater.course.grade.name || '三年级',
        'user_tel_no': stater.mine.state.mobile || ''
      };
      utils.bury('yd_izhikang_header_tel_consult', obj);

      window.location.href = `tel:${  this.logo.details}`
    }
  },
  mounted() {
    // 当切换城市为其他时，获取不到city参数，需要从匹配路径中获取
    let city = CityCodeData.getCityByShort(this.$route.query.city || this.$route.params.city);
    console.log('当前城市：', city);
    let obj = {
      city_code: city.city_code,
      open_city: city.open_city == 1
    };

    //changeCity改变之后，更新store，此时只是更新了city；进入页面之后会重新刷新页面，所以需要重新ip定位
    this.$store.commit('setCity', city);
    this.$store.dispatch('getLogo', obj);

    let vm = this;
    //判断如果是已经登录的用户，并且带有校区城市，则不再获取地理位置
    localforage.getItem('izk-user').then(function(userData) {
      if (userData && userData.student_id) {
        if (this.$route.path.indexOf('diagnosisCourse') ===-1){
          vm.$store.dispatch('getUseInfo');  //每次进来都要重新获取信息，以防信息更改
        }
        //vm.$store.commit('setCity', CityCodeData.getCityByCode(userData.city_code))
        return;
      }
      //智康app不获取位置信息
      if (!window.mobile){
        vm.getLocation();
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/components/public/header/HeaderVM.js